namespace appn.views.users.edit {

    class InitArgs {
        isDisableEdit: boolean = false;
        deleteDeviceMsg: string = appn.emptyString;
        userId: number = 0;
        canSeeCheckboxes: boolean = false;
        providerType: string = emptyString;
        usersAjaxUserDeleteInformation: string = emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        if (_initArgs.isDisableEdit) {
            $('form#appnForm :input').not('.card-btn-expand-or-collapse').prop('disabled', true);
            $('.addMetaItem').hide();
            $('.removeDevice').hide();
        }

        addEvents();

        if ($('.navbar-nav-right button[value*="Delete"]').length > 0)
            addTrashMessage($('.navbar-nav-right button[value*="Delete"]'), $('#UserDetail_LoginId').val() as string);
    }

    function addEvents() {
        $('.removeDevice').click(function(e) {
            e.preventDefault();
            const id = $(this).attr('id');

            appn.dialog.confirm({
                modalColor: 'modal-warning',
                title: T('Delete Device'),
                message: _initArgs.deleteDeviceMsg,
                buttons: {
                    confirm: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    }
                },
                callback: function(result: any) {
                    if (result) {
                        $('form#appnForm').append('<input type="hidden" value="' + id + '" name="RemovedDevice" />');
                        $('form#appnForm').submit();
                    }
                }
            });
        });

        $('#btn-genIntegrationKey1').on('click', function(e) {
            e.preventDefault();
            createApiKey(1);
        });

        $('#btn-genIntegrationKey2').on('click', function(e) {
            e.preventDefault();
            createApiKey(2);
        });

        // hook up checkboxes for mass delete
        $(document).on('change', '.appnGlobalConfirmDelete input[id^="user_"]', function() {
            $('#isMassDelete').val($('.appnGlobalConfirmDelete input[id^="user_"]').prop('checked'));
        });
    }

    function createApiKey(userApiNumber: number) {
        const $form = $('form#appnForm');
        $form.append('<input type="hidden" name="RegenAPIKey' + userApiNumber + '" value="true" />');
        $form.append('<input type="hidden" name="submitType" value="Save" />');
        $form.submit();
    }

    function addTrashMessage(button: JQuery<HTMLElement>, loginId: string) {
        button.attr('data-deletedetail', emptyString);
        button.attr('data-deletemessage', emptyString);

        const loginIds: Array<string> = [];

        loginIds.push(loginId);

        appn.ajax.post({
            url: _initArgs.usersAjaxUserDeleteInformation,
            dataType: 'json',
            data: { userLoginIds: loginIds, requestingProviderId: requestProvider.id },
            done: function(userDetailLists: Array<Array<UserDetailResult>>) {
                const userDetailsList: Array<UserDetailResult> = [];

                // Take the highest level user with this email address
                userDetailLists.forEach(function(userDetailList: Array<UserDetailResult>, index: number, original: Array<Array<UserDetailResult>>) {
                    const topUser = userDetailList.filter((o, i, a) => {
                        return o.ProviderId === requestProvider.id;
                    })[0];
                    userDetailsList.push({
                        Id: topUser.Id,
                        FullName: `${topUser.LastName}, ${topUser.FirstName}`,
                        Email: topUser.Email,
                        LoginId: topUser.LoginId,
                        Count: userDetailList.length,
                        FirstName: topUser.FirstName,
                        LastName: topUser.LastName,
                        Status: topUser.Status,
                        HasWebAccess: topUser.HasWebAccess,
                        Level: topUser.Level,
                        Type: topUser.Type,
                        ProviderId: requestProvider.id
                    });
                });

                if (!utils.hasValue(userDetailsList)) {
                    button.attr('disabled', 'disabled');
                    return;
                }

                button.removeAttr('disabled');
                let msg;
                let removeAllMessage = emptyString;
                let userStat = emptyString;

                const user = userDetailsList[0];
                if (user.Count! > 1 && _initArgs.canSeeCheckboxes) {
                    const hint = buildHint(user.Level);
                    const text = _initArgs.providerType === 'Vendor' ? T('Remove user from all associated clients') : _initArgs.providerType === 'Enterprise' ? T('Remove user from all associated environments') : emptyString;
                    userStat = _initArgs.providerType === 'Vendor' ? T('(<b>{0}</b> associated clients)') : _initArgs.providerType === 'Enterprise' ? T('(<b>{0}</b> associated environments)') : emptyString;
                    if (hint.hasValue() && text.hasValue())
                        removeAllMessage = elementBuilder.buildCheckboxWithHint(text, hint, undefined, `user_${user.Id}`, undefined, `user_${user.Id}`, undefined);
                }

                msg = `<p><b>${user.FullName}</b>${userStat.hasValue() ? ' ' + T(userStat, user.Count) : emptyString}` + T(' and all their associated data will be permanently deleted.') + `</p>${removeAllMessage.hasValue() ? removeAllMessage : emptyString}`;
                
                const p = elementBuilder.createElement('p', undefined, undefined, undefined, msg);
                const msgWarning = T('The selected item(s) will be <b>permanently deleted</b> with <b>no option</b> to recover this data.');
                const p2 = elementBuilder.createElement('p', 'mt-4', undefined, undefined, msgWarning);

                button.attr('data-deletedetail', JSON.stringify(p.outerHTML));
                button.attr('data-deletemessage', p2.outerHTML);
            },
            always: function() {
                appn.dialog.removeContentSpinner($('#manageUsersDialog'));
            }
        });
    }

    function buildHint(level: AccessLevel | undefined): string {
        const clientHint = T('This user is has {0} access and the organization is a client of a Vendor. Check the box to remove this user from all client accounts linked with this Vendor. If you continue without removing this user from all other clients, you may incur additional user license fees.', level === AccessLevel.VendorAdmin ? 'Vendor Admin' : level === AccessLevel.SuperAdmin ? 'Super Admin' : emptyString);
        const enviroHint = T('This user is has {0} access and the organization is part of an Enterprise Toolkit. Check the box to remove this user from all environments. If you continue without removing this user from all other environments, you may incur additional user license fees.', level === AccessLevel.EnterpriseAdmin ? 'Enterprise Admin' : level === AccessLevel.SuperAdmin ? 'Super Admin' : emptyString);

        return _initArgs.providerType === 'Vendor' ? clientHint : _initArgs.providerType === 'Enterprise' ? enviroHint : emptyString;
    }

    interface UserInfo {
        FullName: string | undefined;
        Count: number | undefined;
    }

    interface UserDetailResult extends UserInfo {
        Id: number | undefined;
        LastName: string | undefined;
        FirstName: string | undefined;
        Email: string | undefined;
        LoginId: string;
        Status: UserStatus | undefined;
        Type: UserType | undefined;
        HasWebAccess: boolean | undefined;
        Level: AccessLevel | undefined;
        ProviderId: number;
    }

    enum AccessLevel {
        ReadOnly = 10,
        User = 20,
        Admin = 30,
        EnterpriseAdmin = 40,
        VendorAdmin = 50,
        SuperAdmin = 99
    }
}
